module.exports = __webpack_public_path__ + "img/PD-Board.9d4b50d9.png";